import React, { useEffect, useState, useRef } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'
import setCountryAction from '../../redux/actions/createReferenceActions/actionCountry';
import setCityAction from '../../redux/actions/createReferenceActions/actionCity';
import setProvinceAction from '../../redux/actions/createReferenceActions/actionProvince'
import setZipAction from '../../redux/actions/createReferenceActions/actionZip'
import setStreetAction from '../../redux/actions/createReferenceActions/actionStreet';
import setLongAction from '../../redux/actions/createReferenceActions/actionLong'
import setLatAction from '../../redux/actions/createReferenceActions/actionLat'
import CityForm from './CityFormRef';
import ZipCodeForm from './ZipCodeForm';
import CountryFormRef from "./CountryFormRef";
import ProvinceForm from "./ProvinceFormRef";
import StreetForm from "./StreetForm";

export default function GooglePlacesAutocomplete() {

  const locationError = useSelector(state => state.createRefState.countryError)
  const dispatch = useDispatch()
  const { t } = useTranslation();
  const isFirstRender = useRef(true)
  const [searchValue, setSearchValue] = useState("");
  const [values, setValues] = useState([{ formatted_address: "" }]);
  const [city, setCity] = useState('');
  const [zip, setZip] = useState('');
  const [country, setCountry] = useState('');
  const [province, setProvince] = useState('');
  const [street, setStreet] = useState('');

  let town = [];

  useEffect(() => {

    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }

    let streetNumber = '';
    // let adresse = '';

    // if (searchValue) {
    //   adresse += searchValue
    // }
    if(searchValue.length > 0) {
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${searchValue}&key=AIzaSyC8r00C2TZM5wN-vgV1is8yRSNAp65gHHg&result_type=locality&region=GB&language=${localStorage.getItem('language')}`)
      .then(response => response.json())
      .then((data) => {

        data.results[0].address_components.map(async (keyName, i) => {
          // Nummer              
          if (keyName.types.includes('street_number')) {
            //  console.log("Strassennr: " + keyName.long_name)
            streetNumber = keyName.long_name;
          }
          // Strasse
          if (keyName.types.includes('route')) {
            // console.log("Strasse: " + keyName.long_name)
            dispatch(setStreetAction(keyName.long_name + " " + streetNumber));
            setStreet(keyName.long_name + " " + streetNumber);
          }

          // Stadt, wenn keine Province dann city = province
          //  if(keyName.types.includes('sublocality_level_1')) {
          //     town.push(keyName.long_name)
          //     dispatch(setCityAction(keyName.long_name));
          //     setCity(keyName.long_name)
          //   } else if(keyName.types.includes('sublocality_level_2') && town.length == 0) {
          //       town.push(keyName.long_name)
          //       dispatch(setCityAction(keyName.long_name));
          //       setCity(keyName.long_name)
          //   } else if(keyName.types.includes('sublocality_level_3') && town.length == 0) {
          //       town.push(keyName.long_name)
          //       dispatch(setCityAction(keyName.long_name));
          //       setCity(keyName.long_name)
          //   } else if(keyName.types.includes('sublocality_level_4') && town.length == 0) {
          //       town.push(keyName.long_name)
          //       dispatch(setCityAction(keyName.long_name));
          //       setCity(keyName.long_name)
          //   } else if(keyName.types.includes('sublocality_level_5') && town.length == 0) {
          //       town.push(keyName.long_name)
          //       dispatch(setCityAction(keyName.long_name));
          //       setCity(keyName.long_name)
          // } 
          if (keyName.types.includes('locality') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('postal_town') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_1') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_2') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_3') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_4') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_5') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_6') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          } else if (keyName.types.includes('administrative_area_level_7') && town.length === 0) {
            town.push(keyName.long_name)
            dispatch(setCityAction(keyName.long_name));
            setCity(keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          }
          // Bundesland, wenn kein Bundesland dann Stadt = Bundesland
          if (keyName.types.includes('administrative_area_level_1')) {
            // console.log("Bundesland: " + keyName.long_name)
            dispatch(setProvinceAction(keyName.long_name));
            setProvince(keyName.long_name);
          }
          // Land
          if (keyName.types.includes('country')) {
            // console.log("Land: " + keyName.long_name)
            dispatch(setCountryAction(keyName.long_name));
            setCountry(keyName.long_name);
          }
          // PLZ
          if (keyName.types.includes('postal_code')) {
            // console.log("PLZ: " + keyName.long_name)
            dispatch(setZipAction(keyName.long_name));
            setZip(keyName.long_name);
          } 
        })

        if (data.results !== null) {
          setValues(data.results)
        }
      }).catch((error) => {
        // console.log("Error by address: ", error);
      });
    }
  }, [searchValue])

  const handleChange = (event) => {
    setSearchValue(event.target.value)
    setZip("");
    dispatch(setZipAction(""));
    setCity("");
    dispatch(setCityAction(""));
    setCountry("");
    dispatch(setCountryAction(""));
    setProvince("");
    dispatch(setProvinceAction(""));
    setStreet("");
    dispatch(setStreetAction(""));
  }

  const handleChangeForm = (event, value) => {
    if (value !== null) {
      values.map((val) => {
        if(val.formatted_address === value) {
          dispatch(setLongAction(val.geometry.location.lng))
          dispatch(setLatAction(val.geometry.location.lat))
        }
        return ''
      })
      setSearchValue(value)
    }
  }

  return (
    <div>
      <Autocomplete
        id="combo-box-country"
        onChange={handleChangeForm}
        options={values.map((option) => option.formatted_address || null || '')}
        filterOptions={(x) => x}
        noOptionsText={'Wrong input data'}
        sx={{
          "&:hover ": {
              borderColor: "rgb(0,191,255)"
          },
          '& label.Mui-focused': {
              color: 'white'
          },
          '& .MuiAutocomplete-tag':{
              color: 'black',
              backgroundColor: "white",
          },
          "& .Mui-focused ": {
            color: 'white'
          },
          '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                  borderColor: 'rgb(0,191,255)',
              },
              '&.Mui-focused fieldset': {
                  borderColor: 'rgb(47, 79, 79)',
              },
          },
      }}
        renderInput={(params) => <TextField {...params} error={locationError} style={{ fontSize: 30, marginTop: 10, marginBottom: 0, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300 }}
          onChange={handleChange} label={t('create_ref.location') + "*"} variant="outlined" />}
      />

      <CountryFormRef country={country} searchVal={searchValue} />
      <CityForm city={city} searchVal={searchValue} />
      <ZipCodeForm zip={zip} searchVal={searchValue} />
      <ProvinceForm province={province} searchVal={searchValue} />
      <StreetForm street={street} searchVal={searchValue} />

    </div>
  )
}